module.exports = __webpack_public_path__ + "static/media/BSTN.48abe696.svg";